import {
  Component,
  Input,
  HostListener,
  ElementRef
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'suka-topbar-menu',
  template: `
    <li
      class="topbar__submenu"
      style="height: 100%"
    >
      <a
        class="topbar__menu-item topbar__menu-title"
        [href]="href"
        role="menuitem"
        tabindex="0"
        aria-haspopup="true"
        [attr.aria-expanded]="expanded">
        <ng-content></ng-content>
        <suka-icon icon="chevron-down" class="topbar__menu-arrow" aria-hidden="true"></suka-icon>
      </a>
      <ul class="topbar__menu" role="menu">
        <ng-content select="suka-topbar-item"></ng-content>
      </ul>
    </li>
  `
})
export class TopbarMenu {
  @Input() set href(v: string) {
    this._href = v;
  }

  get href() {
    return this.domSanitizer.bypassSecurityTrustUrl(this._href) as string;
  }

  @Input() trigger: 'click' | 'mouseover' = 'click';

  public expanded = false;

  protected _href = 'javascript:void(0)';

  constructor(protected domSanitizer: DomSanitizer, protected elementRef: ElementRef) { }

  @HostListener('click')
  onClick() {
    if (this.trigger === 'click') {
      this.expanded = !this.expanded;
    }
  }

  @HostListener('mouseover')
  onMouseOver() {
    if (this.trigger === 'mouseover') {
      this.expanded = true;
    }
  }

  @HostListener('mouseout')
  onMouseOut() {
    if (this.trigger === 'mouseover') {
      this.expanded = false;
    }
  }

  @HostListener('focusout', ['$event'])
  onFocusOut(event) {
    if (!this.elementRef.nativeElement.contains(event.relatedTarget)) {
      this.expanded = false;
    }
  }
}
